// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Status_componentWrapper__iljH4","message":"Status_message__vebbT"};